// État module : le plugin qui reçoit l'annonce de Nuxt et le bandeau qui l'affiche doivent lire le
// même identifiant, et le bandeau se remonte à chaque changement de layout.
const latestBuildId = ref<string | null>(null);

export function useLatestBuild (): { latestBuildId: Ref<string | null> } {
  return { latestBuildId };
}
